exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-page-search-wrapper[data-v-360c0372] { margin-bottom: 15px;\n}\n.pending-item-row[data-v-360c0372] { line-height: 24px;\n}\n.default-supplier-tip[data-v-360c0372] { color: #888;\n}\n", ""]);

// exports
